import { Route, Routes, useLocation } from "react-router-dom";
import Header from "./components/header/header";
import BrandsPage from "./pages/brandsPage/brandsPage";
import Products from "./components/products/products";
import ViewAllNewArrivals from "./pages/viewAllNewArrivals/viewAllNewArrivals";
import ViewAllTopSelling from "./pages/viewAllTopSellling/ViewAllTopSelling";
import HomePage from "./pages/home/Home";
import ViewAllOnSale from "./pages/viewAllOnSale/viewAllOnSale";
import { Signup } from "./pages/signup/signup";
import { NotFound } from "./pages/notFound/notFound";
import { Login } from "./pages/login/login";
import { Profile } from "./pages/profile/profile";
import ProductDetails from "./pages/productDetails/productDetails";
import SearchResults from "./pages/searchResults/searchResults";
import About from "./pages/aboutUs/aboutUs";
import Features from "./pages/features/features";
import Works from "./pages/works/works";
import Career from "./pages/career/career";
import CustomerSupport from "./pages/customersSupport/customersSupport";
import DeliveryDetails from "./pages/deliveryDetails/deliveryDetails";
import TermsAndConditions from "./pages/termsConditions/termsConditions";
import PrivacyPolicy from "./pages/privacyPolicy/privacyPolicy";
import AccountFAQ from "./pages/accountFAQ/accountFAQ";
import { ManageAccounts, Payment } from "@mui/icons-material";
import ManageDeliveries from "./pages/manageDeliveries/manageDeliveries";
import Orders from "./pages/orders/orders";
import Payments from "./pages/paymentFAQ/paymentFAQ";
import Ebooks from "./pages/eBooks/eBooks";
import DevelopmentTutorial from "./pages/developmentTutorial/developmentTutorial";
import HowToBlog from "./pages/howToBlog/howToBlog";
import YoutubePlaylist from "./pages/youtubePlaylist/youtubePlaylist";
import OpenRoles from "./pages/openRoles/openRoles";
import ComingSoon from "./components/commingSoon/commingSoon";
import ViewAllTrendingPage from "./pages/viewAllTrending/viewAllTrending";

export default function App() {
  const location = useLocation();
  const hideHeaderRoutes = ["/login", "/signup"];

  const shouldShowHeader = !hideHeaderRoutes.includes(location.pathname);
  return (
    <>
      {shouldShowHeader && <Header />}
      <Routes>
        <Route path="/" element={<HomePage />} />

        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/brands" element={<BrandsPage />} />
        <Route path="/brands-products" element={<Products />} />
        <Route path="/coming-soon" element = {<ComingSoon/>}/>
        <Route path="view-all-newArrivals" element={<ViewAllNewArrivals />} />
        <Route path="view-all-topSelling" element={<ViewAllTopSelling />} />
        <Route path="view-all-trending" element={<ViewAllTrendingPage />} />
        <Route path="view-all-onSale" element={<ViewAllOnSale />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="product-details/:id" element={<ProductDetails />} />
        <Route path="search" element={<SearchResults />} />
        <Route path="/company/about-us" element={<About />} />
        <Route path="/company/features" element={<Features />} />
        <Route path="/company/works" element={<Works />} />
        <Route path="/company/career" element={<Career />} />
        <Route path="/help/customers-support" element={<CustomerSupport />} />
        <Route path="/help/delivery-details" element={<DeliveryDetails />} />
        <Route path="/help/terms-conditions" element={<TermsAndConditions />} />
        <Route path="/help/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/FAQ/Account" element={<AccountFAQ />} />
        <Route path="/FAQ/manage-deliveries" element={<ManageDeliveries />} />
        <Route path="/FAQ/orders" element={<Orders />} />
        <Route path="/FAQ/payment" element={<Payments />} />
        <Route path="/resources/ebooks" element={<Ebooks />} />
        <Route path="/resources/development-tutorial" element={<DevelopmentTutorial />} />
        <Route path="/resources/how-to-blog" element={<HowToBlog />} />
        <Route path="/resources/youtube-play-list" element={<YoutubePlaylist />} />
        <Route path="/company/career/openRoles" element={<OpenRoles />} />
        <Route path="*" element={<NotFound />} />
      </Routes> 
      
    </>

  )
}